import { Component } from '@angular/core';
import moment from 'moment';
/**
 * Generated class for the CoDateComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-date',
  templateUrl: 'co-date.html'
})
export class CoDateComponent {

  date: string;
  dateFunction: any;

  constructor() {
    this.date = moment().format('MMMM D');
  }
  
  ngOnInit() {
    this.dateFunction = setInterval( () => {
      this.date = moment().format('MMMM D');
    }, 5000);
  }

  ngOnDestroy() {
    clearInterval(this.dateFunction);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-date/co-date.ts